import React, { useRef } from "react";

import { Input } from "./Input";
import type { InputProps } from "./Input";
import { IInputHours, useInputHours } from "../../hooks/useInputHours";
import { validateTimeInput } from "../../utils";
import useForkRef from "../../utils/useForkRef";

export interface InputHoursProps
  extends Omit<InputProps, "value" | "onChange">,
    IInputHours {}

export const InputHours = React.forwardRef<HTMLInputElement, InputHoursProps>(
  (
    {
      value: defaultValue,
      onCancel,
      onSave,
      onEnterKeyPress: externalEnterKeyPress,
      allowEmptyValue,
      withLeadingZero = true,
      validation = validateTimeInput,
      incrementOnlySelected = false,
      minuteIncrement = 1,
      className,
      onChange: externalOnChange,
      onClick: externalOnClick,
      align = "center",
      ...rest
    },
    ref
  ) => {
    const inputRef = useRef<HTMLInputElement>(null);
    const handleRef = useForkRef(ref, inputRef);

    const { inputProps } = useInputHours(
      {
        value: defaultValue,
        withLeadingZero,
        onSave,
        validation,
        allowEmptyValue,
        onCancel,
        minuteIncrement,
        incrementOnlySelected,
        onEnterKeyPress: externalEnterKeyPress,
        onChange: externalOnChange,
        onClick: externalOnClick,
      },
      inputRef
    );

    const { value, onBlur, onKeyDown, onChange, onClick, onDoubleClick } =
      inputProps;

    return (
      <Input
        {...rest}
        align={align}
        className={className}
        placeholder={withLeadingZero ? "00:00" : "0:00"}
        value={value}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
        onChange={onChange}
        onClick={onClick}
        onDoubleClick={onDoubleClick}
        ref={handleRef}
        autoComplete="off"
      />
    );
  }
);

InputHours.displayName = "InputHours";
